var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-pagination',{attrs:{"value":_vm.value,"length":_vm.pages,"total-visible":7,"color":"primary"},on:{"input":function($event){return _vm.emitInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }